// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"73f65694","administration":"d45d2eb4"}[chunkId] + ".chunk.js";
};